import React, { Component, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  LogoutOutlined,
  CoffeeOutlined,
  ContainerOutlined,
  BulbOutlined,
  SmileOutlined
} from "@ant-design/icons";
import "./index.css";
import { Layout, Menu, Button, message } from "antd";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  Link,
  useHistory,
} from "react-router-dom";
import { Announcement } from "../../components/announcement";
import { HomePage } from "../../components/homepage";
import { PersonalInformation } from "../../components/personalInformation";
import { ApplicationMaterials } from "./components/applicationMaterials";
import { ResultQuery } from "./components/resultQuery";

const { Header, Sider, Content } = Layout;

export const StudentHome = () => {
  const history = useHistory(); // 获取history对象
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  if (!userInfo) {
    message.error("请登录！！！")
    history.push("/")
  }
  const [collapsed, setCollapsed] = useState(false);

  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
      onClick: () => handleMenuClick(key), // 添加点击事件
    };
  }

  // 菜单点击处理函数
  const handleMenuClick = (key) => {
    switch (key) {
      case "1":
        history.push("/studenthome/home");
        break;
      case "2":
        history.push("/studenthome/applicationMaterials");
        break;
      case "3":
        history.push("/studenthome/announcement");
        break;
      case "4":
        history.push("/studenthome/resultQuery");
        break;
      case "5":
        history.push("/studenthome/personalInformation");
        break;
      default:
        break;
    }
  };

  const items = [
    getItem("首页", "1", <CoffeeOutlined />),
    getItem("申请材料提交", "2", <ContainerOutlined />),
    getItem("公示窗口", "3",<SmileOutlined />),
    getItem("结果查询", "4", <BulbOutlined />),
    getItem("个人信息", "5", <UserOutlined />),
  ];

  return (
    <div className="Homediv">
      <Layout id="components-layout-demo-custom-trigger">
        <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo" style={{overflow:"hidden",borderRadius:"6px"}} >欢迎您{userInfo.role}:{userInfo.full_name}</div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
            items={items}
          />
        </Sider>
        <Layout className="site-layout">
          <Header
            className="site-layout-background"
            style={{
              padding: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: "trigger",
                onClick: () => setCollapsed(!collapsed),
              }
            )}
            <div
              className="logout"
              onClick={() => {
                history.push("/");
                localStorage.removeItem('userInfo');
              }}
            >
              <LogoutOutlined />
            </div>
          </Header>
          <Content
            className="site-layout-background"
            style={{
              margin: "24px 16px",
              padding: 24,
              minHeight: 280,
            }}
          >
            <Switch>
              <Route path="/studenthome/home" component={HomePage} />
              <Route path="/studenthome/applicationMaterials" render={() => <ApplicationMaterials userInfo={userInfo} />} />
              <Route path="/studenthome/announcement" render={() => <Announcement userInfo={userInfo} />} />
              <Route path="/studenthome/resultQuery" render={() => <ResultQuery userInfo={userInfo} />}/>
              <Route path="/studenthome/personalInformation"  render={() => <PersonalInformation userInfo={userInfo} />}  />
              <Redirect from="/studenthome" to="/studenthome/home" />
              {/* 默认重定向到first页面 */}
            </Switch>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
